module.exports = __webpack_public_path__ + "img/prop-shopping-2-left.d5481f57.png";